export type ChipTone = "coral" | "amber" | "petrol" | "teal";

export type ChipToneOrNeutral = ChipTone | "neutral";

export const OPERATION_ZONE = "America/Sao_Paulo";
